import * as React from "react";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { MoneyPurchaseAnnualAllowanceComponent } from "../../../Common/PaymentsIn/SIPP/MoneyPurchaseAnnualAllowanceComponent";
import { FinancialAdvice } from "../../../Common/PaymentsIn/FinancialAdvice";
import { PaymentType, processTypeEnum, InvalidDpcTransferWarningText, InvalidNonDpcTransferWarningText, IsRestrictedToPensionContributionWarningText } from "../../../Common/Resource/Contents";
import { SinglePayment } from "../../../Common/PaymentsIn/SinglePayment/SinglePayment";
import { IsaAllowance } from "../../../Common/ISA/PaymentsIn/IsaAllowance";
import { IsaHelper } from "../../../Common/Helpers/IsaHelper";
import { PensionProtection } from "../../../Common/PaymentsIn/SIPP/PensionProtection";
import { TransferIn } from "../../../Common/PaymentsIn/TransferIn/TransferIn";
import { SubAccountTypeHelper } from "../../../Common/Helpers/SubAccountTypeHelper";
import { RestrictionStore } from "../../../Common/Restrictions/Variable";
import { BankAccountAction } from "../../../Common/PaymentsIn/BankAccount/BankAccountAction";
import { UserClaim } from "../../../../../../../Wrap/Constants/Enums/UserClaim";
import { Permission } from "../../../../../../Shared/Permission/Permission";
import { checkPermission } from "../../../../../../Shared/Permission/PermissionHelper";
import { inUseBankAccountForContribution } from "../../../Common/PaymentsIn/BankAccount/BankAccountHelper";
import { FsaPermission } from "../../../../../../../Wrap/Models/Models/Company/FsaPermission";
import { CompanyWizardAction } from "../../../../../../Admin/Company/CompanyWizard/Actions/CompanyWizardAction";
import { ClientAccountStore, UserStore } from "../../../../../Stroes/Variable";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { isRestrictedToPensionContribution } from "../../../Common/PaymentsIn/SIPP/ValidationHelper";
import { GiaContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/PersonalPortfolio/GiaContributionModel";
import { IsaContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/OneOffPayment/Isa/IsaContributionModel";
import { PensionContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { WrapCashContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/WrapCash/WrapCashContributionModel";
import { PensionContribution } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContribution";
import { GiaContribution } from "../../../../../../../Wrap/Models/Models/Processes/Apply/PersonalPortfolio/GiaContribution";
import { IsaContribution } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Isa/IsaContribution";
import { WrapCashContribution } from "../../../../../../../Wrap/Models/Models/Processes/Apply/WrapCash/WrapCashContribution";
import { PensionAnnuityAssumption } from "../../../Common/PaymentsIn/SIPP/PensionAnnuityAssumption";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { User } from "../../../../../../../Wrap/Models/Models/User/User";
import { isNullOrEmpty } from "../../../../../../../react-core/Utils/Arrays";
import { Action } from "../../../../../Actions/Action";

interface IPaymentsInProps extends IProcessComponentProps {
    type: SubAccountType;
    data: PensionContributionModel | WrapCashContributionModel | GiaContributionModel | IsaContributionModel;
    subaccountHierarchyId: string; 
    hasCashIsa?: boolean;
}

interface IPaymentsInState {
    transferInDisabled?: boolean;
    disableJourney: boolean;
    hasDisqualifyingPensionCredit: boolean;
    userInfo: User;
}

export class PaymentsIn extends ProcessComponent<IPaymentsInProps, IPaymentsInState> {
    constructor(props: any) {
        super(props);
        this.state = {
            disableJourney: false,
            userInfo: UserStore.getUserInfo(),
            hasDisqualifyingPensionCredit: false
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.setState({ transferInDisabled: RestrictionStore.transferDisabled() });
        CompanyWizardAction.getCompanyFsaPermissionDetail(
            ClientAccountStore.getClientAccountInfo()?.Company, "AdviseInvestments",
            (result: FsaPermission[]) => {
                if (
                    !result.some(
                        (ele) =>
                            ele?.FsaRegulatedActivity?.Name?.toLowerCase() == "AdviseInvestments".toLowerCase() &&
                            ele?.IsInclude &&
                            ele?.IsPermit
                    )
                ) {
                    this.setState({ disableJourney: true });
                }
            }
        );
        Action.getPensionSubAccountSettings(this.props.subaccountHierarchyId, true, (val) => {
            this.setState(
                {
                    hasDisqualifyingPensionCredit: val?.HasDisqualifyingPensionCredit ?? false
                }
            );
        });
    }

    isValid() {
        const flag = super.isValid();
        var isRestrictedProtection = false;
        if ((this.props.data?.Contribution as PensionContribution)?.HasPensionProtection && (this.props.data?.Contribution as PensionContribution)?.PensionProtection) {
            isRestrictedProtection = isRestrictedToPensionContribution(
                (this.props.data?.Contribution as PensionContribution)?.PensionProtection
            );
            if (isRestrictedProtection) {
                this.props.showErrorMsgPopUp([IsRestrictedToPensionContributionWarningText]);
            }
        }

        var passDpcCheck = true;
        if (this.props.type == SubAccountType.Npr) {
            var contribution = this.props.data?.Contribution as PensionContribution;
            var hasAnyDpcTransfer = contribution?.PensionTransfers?.some((t) => t.PensionDetails?.IsDisqualifyingPensionCredits);
            passDpcCheck = this.state.hasDisqualifyingPensionCredit == hasAnyDpcTransfer;

            if (!passDpcCheck && this.state.hasDisqualifyingPensionCredit) {
                this.props.showErrorMsgPopUp([InvalidNonDpcTransferWarningText]);
            }
            else if (!passDpcCheck && !this.state.hasDisqualifyingPensionCredit) {
                this.props.showErrorMsgPopUp([InvalidDpcTransferWarningText]);
            }

        }

        return flag && !this.state.disableJourney && !isRestrictedProtection && passDpcCheck;
    }

    private getProps = (key) => {
        const { onChange, data, showErrorMsgPopUp, isReview } = this.props;
        return {
            data: data[key],
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onChange: (changes) => this.onDataChange(onChange, changes, data, key),
            hasPaymentMethod: true,
            isReview: isReview,
            onSaveNewBankAccountInstruction: (bankAccountInstruction) => {
                bankAccountInstruction.OwnerHierarchyId = data.OwnerHierarchyId;
                BankAccountAction.saveBankInstruction(
                    bankAccountInstruction,
                    data.ClientDetails?.ActorId,
                    processTypeEnum.SinglePaymentTransfer,
                    (savedBankAccountInstruction) => {
                        const changes = [...data.BankAccountInstructions, ...[savedBankAccountInstruction]];
                        this.onDataChange(onChange, changes, data, "BankAccountInstructions");
                    }
                );
            },
            onRemoveBankAccountInstruction: (bankAccountInstruction) => {
                BankAccountAction.removeBankInstruction(bankAccountInstruction, () => {
                    const changes = (data.BankAccountInstructions || []).filter(
                        (x) => x.AccountNumber != bankAccountInstruction.AccountNumber
                    );
                    this.onDataChange(onChange, { BankAccountInstructions: changes }, data);
                });
            },
            inUseBankAccountInstruction: inUseBankAccountForContribution(data?.Contribution),
        };
    };

    private renderFsaError() {
        if (this.state.disableJourney) {
            return <Alert message={"FCA Permissions prevents the following action."} alertType={AlertType.Error} />;
        }
        return <></>;
    }

    private renderPaymentsIn(ClientDetails, AllBankAccounts, BankAccountInstructions) {
        const { Contribution } = this.props.data;
        const { type } = this.props;
        const { onChange, data } = this.props;

        if (SubAccountTypeHelper.isWrapCash(type)) {
            return (
                <>
                    <hr />
                    <SinglePayment
                        {...this.getProps("Contribution")}
                        clientInfo={ClientDetails}
                        checkBoxOption={[PaymentType.Client, PaymentType.ThirdParty]}
                        subAccountType={this.props.type}
                        bankAccounts={AllBankAccounts}
                        bankAccountInstructions={BankAccountInstructions}
                        processType={processTypeEnum.SinglePaymentTransfer}
                        excludeWrapCash={true}
                    />
                    <hr />
                </>
            );
        } else if (SubAccountTypeHelper.isPP(type)) {
            return (
                <>
                    <hr />
                    <SinglePayment
                        {...this.getProps("Contribution")}
                        clientInfo={ClientDetails}
                        checkBoxOption={[PaymentType.Client, PaymentType.ThirdParty]}
                        subAccountType={this.props.type}
                        bankAccounts={AllBankAccounts}
                        bankAccountInstructions={BankAccountInstructions}
                        processType={processTypeEnum.SinglePaymentTransfer}
                    />
                    <Permission userClaim={UserClaim.AdviserPortalSPTAndRegularPaymentTransferInReadWrite}>
                        <TransferIn
                            isPost={false}
                            disabled={this.state.transferInDisabled}
                            data={(Contribution as GiaContribution)?.GiaTransfers}
                            subAccountType={SubAccountType.InvestmentAccount}
                            clientDetails={ClientDetails}
                            jouneryType={processTypeEnum.SinglePaymentTransfer}
                            onChange={(changes) =>
                                this.onDataChange(
                                    (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                                    changes,
                                    data.Contribution
                                )
                            }
                            isReview={this.props.isReview}
                            showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                            onRef={(ref) => this.appendChild(ref)}
                            accountServiceProposition={this.props.data.AccountServiceProposition}
                        />
                    </Permission>
                </>
            );
        } else if (SubAccountTypeHelper.isIsa(type)) {
            const contribution = Contribution as IsaContribution
            return (
                <>
                    <hr />
                    {contribution.IsaAllowance && <IsaAllowance {...this.getProps("Contribution")} />}
                    <hr />
                    <SinglePayment
                        {...this.getProps("Contribution")}
                        clientInfo={ClientDetails}
                        checkBoxOption={[PaymentType.Client, PaymentType.ThirdParty]}
                        hasPaymentMethod={true}
                        subAccountType={this.props.type}
                        bankAccounts={AllBankAccounts}
                        bankAccountInstructions={BankAccountInstructions}
                        processType={processTypeEnum.SinglePaymentTransfer}
                    />
                    <hr />
                    {contribution.IsaTransfers &&
                        type !== SubAccountType.CashIsa &&
                        checkPermission(UserClaim.AdviserPortalSPTAndRegularPaymentTransferInReadWrite) && (
                            <TransferIn
                                subAccountType={SubAccountType.StocksIsa}
                                data={contribution.IsaTransfers}
                                disabled={this.state.transferInDisabled}
                                jouneryType={processTypeEnum.SinglePaymentTransfer}
                                onChange={(changes) =>
                                    this.onDataChange(
                                        (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                                        changes,
                                        data.Contribution
                                    )
                                }
                                showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                                isPost={false}
                                isReview={this.props.isReview}
                                onRef={(ref) => this.appendChild(ref)}
                                hasCashIsa={this.props.hasCashIsa}
                                accountServiceProposition={this.props.data.AccountServiceProposition}
                            />
                        )}
                </>
            );
        } else if (SubAccountTypeHelper.isOnPlatformPension(type)) {
            const contribution = Contribution as PensionContribution
            return (
                <>
                    <hr />
                    <div>
                        { type != SubAccountType.JuniorSipp && (
                        <>
                        <MoneyPurchaseAnnualAllowanceComponent {...this.getProps("Contribution")} /> 
                        <PensionProtection label={"Edit pension protection"} {...this.getProps("Contribution")} /> 
                        </>
                        )}
                    </div>
                    <PensionAnnuityAssumption processType={ProcessType.SinglePayment} {...this.getProps("Contribution")} />
                    <hr />
                    <SinglePayment
                        {...this.getProps("Contribution")}
                        clientInfo={ClientDetails}
                        checkBoxOption={[
                            PaymentType.Client,
                            PaymentType.ThirdParty,
                            PaymentType.EmployerSalaryDeduction,
                            PaymentType.Employer,
                        ]}
                        hasPaymentMethod={true}
                        subAccountType={this.props.type}
                        bankAccounts={AllBankAccounts}
                        bankAccountInstructions={BankAccountInstructions}
                        processType={processTypeEnum.SinglePaymentTransfer}
                    />
                    <hr />
                    {contribution.PensionTransfers &&
                        UserClaim.AdviserPortalSPTAndRegularPaymentTransferInReadWrite && (
                            <TransferIn
                                subAccountType={type}
                                disabled={this.state.transferInDisabled}
                                data={contribution.PensionTransfers}
                                jouneryType={processTypeEnum.SinglePaymentTransfer}
                                onChange={(changes) =>
                                    this.onDataChange(
                                        (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                                        changes,
                                        data.Contribution
                                    )
                                }
                                showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                                isPost={false}
                                isReview={this.props.isReview}
                                onRef={(ref) => this.appendChild(ref)}
                                accountServiceProposition={this.props.data.AccountServiceProposition}
                            />
                        )}
                </>
            );
        }
    }

    public render(): JSX.Element {
        const { ClientDetails, AllBankAccounts, Contribution, BankAccountInstructions } = this.props.data;
        const { type } = this.props;

        if (SubAccountTypeHelper.isOnPlatformPension(type)) {
            return (
                <div>
                    {this.renderFsaError()}
                    <h2>Payments in</h2>
                    <FinancialAdvice {...this.getProps("Contribution")} readonly={this.state.disableJourney} processtype={ProcessType.SinglePayment} />
                    {Contribution?.AdviceGiven != null &&
                        this.renderPaymentsIn(ClientDetails, AllBankAccounts, BankAccountInstructions)}
                </div>
            );
        } else if (SubAccountTypeHelper.isWrapCash(type)) {
            return (
                <div>
                    {this.renderFsaError()}
                    <h2>Payments in</h2>
                    <FinancialAdvice {...this.getProps("Contribution")} readonly={this.state.disableJourney} processtype={ProcessType.SinglePayment} />
                    {Contribution?.AdviceGiven != null &&
                        this.renderPaymentsIn(ClientDetails, AllBankAccounts, BankAccountInstructions)}
                </div>
            );
        } else if (SubAccountTypeHelper.isPP(type)) {
            return (
                <div>
                    {this.renderFsaError()}
                    <h2>Payments in</h2>
                    <FinancialAdvice {...this.getProps("Contribution")} readonly={this.state.disableJourney} processtype={ProcessType.SinglePayment}/>
                    {Contribution?.AdviceGiven != null &&
                        this.renderPaymentsIn(ClientDetails, AllBankAccounts, BankAccountInstructions)}
                </div>
            );
        } else if (SubAccountTypeHelper.isIsa(type)) {
            return (
                <div>
                    {this.renderFsaError()}
                    <h2>Payments in</h2>
                    <FinancialAdvice {...this.getProps("Contribution")} readonly={this.state.disableJourney} processtype={ProcessType.SinglePayment} />
                    {(Contribution?.AdviceGiven != null || IsaHelper.hasPaymentsTransfer(Contribution)) &&
                        this.renderPaymentsIn(ClientDetails, AllBankAccounts, BankAccountInstructions)}
                </div>
            );
        } else {
            return (
                <div>
                    <h2>Payments in</h2>
                </div>
            );
        }
    }
}
